module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"views.dialogTag.tabs.usage":"Usage","views.dialogTag.tabs.trends":"Trends","views.dialogTag.tabs.carbon":"Emissions"}}')
  delete Component.options._Ctor
}
